<template lang="html">
  <div>
    <query-input
        @query-change="updateQueryStr"
    ></query-input>

    <main class="s-content">
      <filters-triggers></filters-triggers>

      <div class="search-wrap">
        <result-info
            :total="result.total"
            :query="queryString"
            :styles="activeFiltersNames.styles"
            :subjects="activeFiltersNames.subjects"
            :types="activeFiltersNames.types"
            :locations="activeFiltersNames.locations"
        ></result-info>
        <!-- masonry
        ================================================== -->
        <div class="row search-result search-result-wrap group test">
          <div class="preloader" :class="{ active: loader}">
            <div id="loader"></div>
          </div>

          <div class="masonry">
            <div class="masonry__brick" v-for="item in result.hits">
              <article class="item-block item-block--thumb">
                <div class="item-block__thumb text-center">
                  <a class="thumb-link"
                     :data-id="item._id"
                     :data-title="item._source.title"
                     @click.prevent="openPreview(item._id)">
                    <img :src="item._source.esPreviewImage" alt="" data-rjs="2">
                  </a>
                </div>
              </article>
            </div>
          </div> <!-- end bricks wrapper -->
        </div>  <!-- end masonry-outer -->

        <!-- pagination
        ================================================== -->
        <div class="row" v-if="result.total > pager.perPage">
          <div class="col-full">
            <pagination
                :total="result.total"
                :per-page="pager.perPage"
                :offset="pager.offset"
                @page-changed="val => pager.offset = val"
            ></pagination>
          </div>
        </div>
      </div>
    </main>  <!-- end s-content -->

    <div data-popup-target="filters-subject" class="popup-overlay">
      <div class="popup-container popup-container--2cols popup-post-filters">
        <h2>Subject filters</h2>
        <div class="popup-post-filters__top-btns">
          <div class="btn btn--primary toggle-filters">Toggle disabled filters</div>
        </div>
        <div class="row">
          <div class="col-full">
            <ul class="popup-container__filter-list"
                v-if="filters['subject-filters']
                    && aggregations.subjects
                    && aggregations.subjects.objects
                    && aggregations.subjects.objects.buckets">
              <li v-for="(value, key) in filters['subject-filters']"
                  :class="{ disabled: filterDisabled(key, 'subjects') }">
                <input
                    type="checkbox"
                    :id="'subject'+key"
                    :value="key"
                    name="subjects"
                    :disabled="filterDisabled(key, 'subjects')"
                    @change="filterChange">
                <label :for="'subject'+key">{{ value }}</label>
              </li>
            </ul>
          </div>
          <div class="popup-container__filter-buttons">
            <div class="col-full">
              <button type="submit"
                      value="Show"
                      class="big-purple-button popup-container__button full-width"
                      @click="filterApply">Show Selected
              </button>
            </div>
          </div>
        </div>
        <a href="#" title="close" class="popup-container__close">Close</a>
      </div>
    </div>
    <div data-popup-target="filters-style" class="popup-overlay">
      <div class="popup-container popup-container--2cols popup-post-filters">
        <h2>Style filters</h2>
        <div class="popup-post-filters__top-btns">
          <div class="btn btn--primary toggle-filters">Toggle disabled filters</div>
        </div>
        <div class="row">
          <div class="col-full">
            <ul class="popup-container__filter-list"
                v-if="filters['subject-filters']
                    && aggregations.styles
                    && aggregations.styles.objects
                    && aggregations.styles.objects.buckets">
              <li v-for="(value, key) in filters['style-filters']" :class="{ disabled: filterDisabled(key, 'styles') }">
                <input
                    type="checkbox"
                    :id="'style'+key"
                    :value="key"
                    name="styles"
                    :disabled="filterDisabled(key, 'styles')"
                    @change="filterChange">
                <label :for="'style'+key">{{ value }}</label>
              </li>
            </ul>
          </div>
          <div class="popup-container__filter-buttons">
            <div class="col-full">
              <button type="submit"
                      value="Show"
                      class="big-purple-button popup-container__button full-width"
                      @click="filterApply">Show Selected
              </button>
            </div>
          </div>
        </div>
        <a href="#" title="close" class="popup-container__close">Close</a>
      </div>
    </div>
    <div data-popup-target="filters-type" class="popup-overlay">
      <div class="popup-container popup-container--2cols popup-post-filters">
        <h2>Type filters</h2>
        <div class="popup-post-filters__top-btns">
          <div class="btn btn--primary toggle-filters">Toggle disabled filters</div>
        </div>
        <div class="row">
          <div class="col-full">
            <ul class="popup-container__filter-list"
                v-if="filters['subject-filters']
                    && aggregations.types
                    && aggregations.types.objects
                    && aggregations.types.objects.buckets">
              <li v-for="(value, key) in filters['type-filters']" :class="{ disabled: filterDisabled(key, 'types') }">
                <input type="checkbox"
                       :id="'type'+key"
                       :value="key"
                       name="types"
                       :disabled="filterDisabled(key, 'types')"
                       @change="filterChange">
                <label :for="'type'+key">{{ value }}</label>
              </li>
            </ul>
          </div>
          <div class="popup-container__filter-buttons">
            <div class="col-full">
              <button type="submit"
                      value="Show"
                      class="big-purple-button popup-container__button full-width"
                      @click="filterApply">Show Selected
              </button>
            </div>
          </div>
        </div>
        <a href="#" title="close" class="popup-container__close">Close</a>
      </div>
    </div>
    <div data-popup-target="filters-location" class="popup-overlay">
      <div class="popup-container popup-container--2cols popup-post-filters">
        <h2>Location filters</h2>
        <div class="popup-post-filters__top-btns">
          <div class="btn btn--primary toggle-filters">Toggle disabled filters</div>
        </div>
        <div class="row">
          <div class="col-full">
            <ul class="popup-container__filter-list"
                v-if="filters['subject-filters']
                    && aggregations.locations
                    && aggregations.locations.objects
                    && aggregations.locations.objects.buckets">
              <li v-for="(value, key) in filters['location-filters']"
                  :class="{ disabled: filterDisabled(key, 'locations') }">
                <input
                    type="checkbox"
                    :id="'location'+key"
                    :value="key"
                    name="locations"
                    :disabled="filterDisabled(key, 'locations')"
                    @change="filterChange">
                <label :for="'location'+key">{{ value }}</label>
              </li>
            </ul>
          </div>
          <div class="popup-container__filter-buttons">
            <div class="col-full">
              <button
                  type="submit"
                  value="Show"
                  class="big-purple-button popup-container__button full-width"
                  @click="filterApply"
              >Show Selected
              </button>
            </div>
          </div>
        </div>
        <a href="#" title="close" class="popup-container__close">Close</a>
      </div>
    </div>

    <preview-modal
        :currentImage="modalPreview.current"
        :prevImage="modalPreview.prev"
        :nextImage="modalPreview.next"
        @changeImage="val => openPreview(val)"
        @closeModal="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
// Component created to perform search for illustration without reloading of page

import QueryInput from './QueryInput';
import FiltersTriggers from './FiltersTriggers';
import ResultInfo from './ResultInfo';
import PreviewModal from './PreviewModal';
import _ from 'lodash';

export default {
  components: {
    'query-input': QueryInput,
    'filters-triggers': FiltersTriggers,
    'result-info': ResultInfo,
    'preview-modal': PreviewModal
  },
  props: {
    requestUrl: String,
    filtersUrl: String,
  },
  data() {
    return {
      error: null,
      queryString: '',
      filters: {},
      activeFiltersNames: {
        styles: [],
        locations: [],
        types: [],
        subjects: []
      },
      searchParams: {
        query: '',
        size: 25,
        from: 0,
        styles: [],
        locations: [],
        types: [],
        subjects: []
      },
      result: {
        total: 0,
        hits: []
      },
      aggregations: {},
      pager: {
        offset: 0,
        perPage: 25
      },
      loader: false,
      modalPreview: {
        current: null,
        next: true,
        prev: true
      }
    };
  },
  methods: {
    // Listen event of changing QueryInput component and change appropriate variable
    updateQueryStr: function (val) {
      this.queryString = val;
    },
    // Send data on search endpoint and get data on callback
    searchRequest: function () {
      this.loader = true;
      this.axios.get(this.requestUrl, {
        params: this.searchParams
      })
        .then(response => {
          this.result = _.cloneDeep(response.data.results.hits);
          this.aggregations = _.cloneDeep(response.data.results.aggregations);
        })
        .catch(e => {
          console.error(e);
          this.loader = false;
        });
    },
    // Get filters from endpoint
    getFilters: function () {
      this.axios.get(this.filtersUrl)
        .then(response => {
          this.filters = _.cloneDeep(response.data.filters);
        })
        .catch(e => {
          console.error(e);
        });
    },
    // Write in search params selected filters
    filterChange: function (e) {
      let filtersName = e.target.getAttribute('name');

      if (e.target.checked) {
        this.searchParams[filtersName].push(e.target.value);
      } else {
        _.remove(this.searchParams[filtersName], function (n) {
          return n == e.target.value;
        });
      }
    },
    // Applying filters and run searchRequest()
    filterApply: function () {
      this.activeFiltersNames.styles = [];
      _.forEach(this.searchParams.styles, (item) => {
        this.activeFiltersNames.styles.push(this.filters['style-filters'][item]);
      });
      this.activeFiltersNames.subjects = [];
      _.forEach(this.searchParams.subjects, (item) => {
        this.activeFiltersNames.subjects.push(this.filters['subject-filters'][item]);
      });
      this.activeFiltersNames.types = [];
      _.forEach(this.searchParams.types, (item) => {
        this.activeFiltersNames.types.push(this.filters['type-filters'][item]);
      });
      this.activeFiltersNames.locations = [];
      _.forEach(this.searchParams.locations, (item) => {
        this.activeFiltersNames.locations.push(this.filters['location-filters'][item]);
      });

      if (this.pager.offset != 0) {
        this.pager.offset = 0;
      } else {
        this.searchRequest();
      }
    },
    pageChanged: function (offset) {
      this.pager.offset = offset;
    },
    // Refresh masonry when all data has been load and written in DOM
    refreshMasonry: _.debounce(function () {
      let masonry = new window.masonry(document.querySelector('.masonry'), {
        itemSelector: '.masonry__brick',
        percentPosition: true,
        horizontalOrder: true,
        resize: true
      });
        // masonry.on('');
      this.loader = false;
    }, 300),
    // Scrolling to top of the page
    scrollTop: function () {
      $('html, body').animate({
        scrollTop: $(".s-page-header").offset().top
      }, 500);
    },
    // Open preview modal which is provided by component PreviewModal
    openPreview: function (id) {
      if (!$('.search-image-preview-modal').hasClass('is-visible')) {
        $('.search-image-preview-modal').addClass('is-visible');
        $('body').removeClass('overflow-hidden');
      }

      let index = _.findIndex(this.result.hits, (item) => {
        return item._id == id;
      });
      this.modalPreview.current = this.result.hits[index];
      if (index <= 0) {
        this.modalPreview.prev = false;
      } else {
        this.modalPreview.prev = this.result.hits[index - 1];
      }
      if (index >= this.pager.perPage) {
        this.modalPreview.next = false;
      } else {
        this.modalPreview.next = this.result.hits[index + 1];
      }
    },
    // Close preview modal
    closePreview: function () {
      this.modalPreview.current = null;
    },
    // Check is filter disabled or not
    filterDisabled: function (key, filterName) {
      let result = _.findIndex(this.aggregations[filterName].objects.buckets, function (item) {
        return item.key == key;
      });
      return result == -1;
    }
  },
  watch: {
    aggregations: {
      handler: function () {
        let filters = this.filters;
        this.filters = null;
        this.filters = filters;
      },
      deep: true
    },
    queryString: _.debounce(function () {
      this.pager.offset = 0;
      this.searchParams.query = this.queryString;
    }, 400),
    'pager.offset': function (newVal) {
      this.searchParams.size = this.pager.perPage;
      this.searchParams.from = this.pager.offset;
      this.scrollTop();
    },
    'searchParams.query': function () {
      this.searchRequest();
    },
    'searchParams.size': function () {
      this.searchRequest();
    },
    'searchParams.from': function () {
      this.searchRequest();
    },
    'result.hits': function () {
      let filters = this.filters;
      this.filters = null;
      this.filters = filters;
      setTimeout(() => {
        $('.search-result-wrap').imagesLoaded(() => {
          this.refreshMasonry();
        });
      }, 100);
    },
  },
  mounted() {
    this.getFilters();
    this.searchRequest();

    // Showing modals with filters
    $(document).on('click', '.toggle-filters', function () {
      $(this).parents('.popup-container').find('.popup-container__filter-list').toggleClass('show-disabled-filters');
    });
    // Avilable to uncheck disabled filters
    $(document).on('click', '.popup-container__filter-list > li', function () {
      if ($(this).hasClass('disabled') && $(this).find('input').is(':checked')) {
        $(this).find('input').prop('disabled', false).click().prop('disabled', true);
      }
    });
  }
};
</script>

<style lang="scss">
  .content-result-info {
    margin-bottom: 1em;
  }

  .search-result-wrap {
    position: relative;
    overflow: hidden;

    .item-block {
      background-color: transparent;
      box-shadow: none;
    }

    .preloader {
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      width: 100%;
      height: 100%;
      z-index: 10;
      background: #fff;

      &.active {
        display: block;
      }
    }

    .masonry__brick {
      width: 290px;
    }
  }

  .popup-post-filters__top-btns {
    margin: 10px 0;
  }

  .popup-container__filter-list li.disabled {
    display: none;

    label {
      color: #ccc;
    }
  }

  .popup-container__filter-list.show-disabled-filters li.disabled {
    display: block;
  }
</style>